import { twMerge } from "tailwind-merge";

interface ChainLabelProps {
  label: string;
  className?: string;
  Icon: React.ElementType;
}

function ChainLabel({ label, className, Icon }: ChainLabelProps) {
  return (
    <span className={twMerge("flex items-center gap-2", className)}>
      <Icon className="h-6 w-6 shrink-0" /> {label}
    </span>
  );
}

export default ChainLabel;
